import * as Yup from "yup";
import { DatePrecision } from "../../../../../../api/API";
import { coherenceError } from "../../../../../../common/PartialDate";

// TODO: @jasonduochen - confirm phone number format
export const phoneValidation = Yup.string().matches(
  /^(?:\(\d{3}\)\s?|\d{3}-)?\d{3}-\d{4}|\d{10}$/,
  "Phone number must be in the format (XXX) XXX-XXXX, XXX-XXX-XXXX, or 10 digits XXXXXXXXXX",
);

export const emailValidation = Yup.string()
  .email("Invalid email format")
  .nullable();

/**
 * A `{value, precision}` pair whose value matches its precision — YEAR needs
 * `YYYY`, MONTH `YYYY-MM`, DAY `YYYY-MM-DD`, PRESENT no value.
 *
 * The form-side counterpart to the `FlexibleDate` pydantic model
 * (`services/models/flexible_date.py`): same rule, same message, enforced before
 * the value can reach a mutation. Use `.nullable()` on the field itself for
 * "not entered yet" — this validates a pair that *is* present.
 */
export const flexibleDateValidation = Yup.object({
  value: Yup.string().nullable().defined(),
  precision: Yup.mixed<DatePrecision>()
    .oneOf(Object.values(DatePrecision))
    .required("Date precision is required"),
}).test("value-matches-precision", "", function (pair) {
  const error = coherenceError(pair?.value ?? null, pair?.precision);
  return error === null || this.createError({ message: error });
});
